import {
  IImageLayer,
  IImageLayerReplacement,
  ImageLayerReplacementTarget,
} from '../designer/layer/LayersState';
import { useMemo } from 'react';
import { rgbToHex } from '../lib/rgbToHex';
import { useTreditionApiUrl } from '../config/configSelectors';

const coverUserImagesBasePath = 'designImages/render';

export const getImageBlobUrlWithoutReplacements = (apiUrl: string, layer: IImageLayer) => {
  return `${apiUrl}${coverUserImagesBasePath}/${window.btoa(
    layer.fileId,
  )}/Kg==/Kg==/${!layer.keepAspectRatio}/1`;
};

export const useImageBlobUrl = (layer: IImageLayer, keepAspectRatio: boolean) => {
  const apiUrl = useTreditionApiUrl();

  return useMemo(() => {
    const fillReplacements = getImageReplacePart(
      ImageLayerReplacementTarget.FillColor,
      layer.replacements,
    );
    const strokeReplacements = getImageReplacePart(
      ImageLayerReplacementTarget.StrokeColor,
      layer.replacements,
    );
    return `${apiUrl}${coverUserImagesBasePath}/${window.btoa(layer.fileId)}/${window.btoa(
      fillReplacements,
    )}/${window.btoa(strokeReplacements)}/${keepAspectRatio ? 'false' : 'true'}/${
      layer.strokeWidth
    }`;
  }, [apiUrl, layer.replacements, layer.fileId, layer.strokeWidth, keepAspectRatio]);
};

function getImageReplacePart(
  target: ImageLayerReplacementTarget,
  replacements: IImageLayerReplacement[],
) {
  return (
    replacements
      .filter(($) => $.target === target)
      .map(($) => `${$.colorOld};#${rgbToHex($.colorNew.rgba)}`)
      .join('|') || '*'
  );
}
